import React from "react";
import { SyncStatusEntity } from "../../../../compliance/domain/entities/SyncStatusEntity";
import { Button } from "../../../../../ui/components/Button";
import { FeatherRefreshCw } from "@subframe/core";

interface SyncStatusCardProps {
  syncStatus: SyncStatusEntity | null;
  loading: boolean;
  syncing: boolean;
  onManualSync: () => Promise<void>;
}

export const SyncStatusCard: React.FC<SyncStatusCardProps> = ({
  syncStatus,
  loading,
  syncing,
  onManualSync,
}) => {
  const formatDate = (dateString?: string) => {
    if (!dateString) return "Never";
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="flex w-full flex-col items-start gap-4 p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div className="flex w-full items-center justify-between">
        <div className="flex flex-col items-start gap-1">
          <span className="text-heading-3 font-heading-3 text-default-font">
            Sync Status
          </span>
          <span className="text-body font-body text-subtext-color">
            Last sync information and manual sync trigger
          </span>
        </div>
        <Button
          variant="brand-primary"
          icon={<FeatherRefreshCw />}
          onClick={onManualSync}
          loading={syncing}
          disabled={syncing || loading}
        >
          {syncing ? "Syncing..." : "Manual Sync"}
        </Button>
      </div>

      {loading ? (
        <div className="flex w-full items-center justify-center p-8">
          <span className="text-body font-body text-subtext-color">
            Loading sync status...
          </span>
        </div>
      ) : syncStatus ? (
        <div className="flex w-full flex-col items-start gap-4">
          <div className="grid grid-cols-2 gap-4 w-full">
            <div className="flex flex-col items-start gap-1">
              <span className="text-caption font-caption text-subtext-color">
                Last Synced At
              </span>
              <span className="text-body font-body text-default-font">
                {formatDate(syncStatus.last_synced_at)}
              </span>
            </div>
            <div className="flex flex-col items-start gap-1">
              <span className="text-caption font-caption text-subtext-color">
                Records Created
              </span>
              <span className="text-body font-body text-default-font">
                {syncStatus.records_created}
              </span>
            </div>
            <div className="flex flex-col items-start gap-1">
              <span className="text-caption font-caption text-subtext-color">
                Records Updated
              </span>
              <span className="text-body font-body text-default-font">
                {syncStatus.records_updated}
              </span>
            </div>
            {syncStatus.errors && syncStatus.errors.length > 0 && (
              <div className="flex flex-col items-start gap-1 col-span-2">
                <span className="text-caption font-caption text-red-600">
                  Errors
                </span>
                <div className="flex flex-col items-start gap-1">
                  {syncStatus.errors.map((error, index) => (
                    <span
                      key={index}
                      className="text-body font-body text-red-600"
                    >
                      {error}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex w-full items-center justify-center p-8">
          <span className="text-body font-body text-subtext-color">
            No sync history available. Click "Manual Sync" to sync compliance
            calendar.
          </span>
        </div>
      )}
    </div>
  );
};

